import React from "react";
import { Star } from "@phosphor-icons/react";

const Stars = ({ value = 0, size = 16 }) => (
  <div className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={size} weight={i <= Math.round(value) ? "fill" : "regular"}
        className={i <= Math.round(value) ? "text-amber-400" : "text-slate-300"} />
    ))}
  </div>
);

export default function SatisfactionStrip({ ratings, testId = "satisfaction-strip" }) {
  if (!ratings) return null;
  const s = ratings.summary || {};
  return (
    <div className="surface-card p-5" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-[0.15em] text-slate-400 font-semibold mb-3">Customer satisfaction</div>
      {ratings.error ? (
        <div className="text-rose-500 text-xs">Couldn't load ratings.</div>
      ) : !s.count ? (
        <div className="text-xs text-slate-400">No ratings yet — clients can rate tickets once they're completed.</div>
      ) : (
        <div className="flex items-center gap-6 flex-wrap">
          <div className="flex items-center gap-3">
            <span className="font-display text-3xl font-bold text-slate-900 tabular-nums">{s.avg}</span>
            <div>
              <Stars value={s.avg} />
              <div className="text-xs text-slate-500 mt-0.5">{s.count} rating{s.count === 1 ? "" : "s"} · {s.response_rate}% response rate</div>
            </div>
          </div>
          <div className="flex-1 min-w-[220px] max-w-sm space-y-1">
            {[5, 4, 3, 2, 1].map((k) => {
              const c = (s.distribution || {})[String(k)] || 0;
              const pct = s.count ? Math.round((c / s.count) * 100) : 0;
              return (
                <div key={k} className="flex items-center gap-2 text-[11px]">
                  <span className="w-6 text-slate-500 tabular-nums">{k} ★</span>
                  <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                    <div className="h-full bg-amber-600 rounded-full" style={{ width: `${pct}%` }} />
                  </div>
                  <span className="w-6 text-right text-slate-600 tabular-nums">{c}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
